import React from 'react'

const ForgotPassword = () => {
  return (
    <div className='flex flex-1 justify-center items-start'>ForgotPassword</div>
  )
}

export default ForgotPassword